import styled from 'styled-components';

import { getTypographyFontColor } from './helpers';

const Caption = styled.div<{ strong?: boolean }>`
    color: ${ ({ color, theme }) => getTypographyFontColor({ color: color || 'tertiary', theme }) };
    font-family: ${ ({ strong, theme }) => (strong ? theme.type.mediumFont : theme.type.regularFont) };
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 16px;
`;

export default Caption;
